import React from "react";

export const useClickOutside = (
  ref: React.RefObject<HTMLDivElement>,
  callback: () => void
) => {
  const handleClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    if (target.classList.contains("pubr-overlay")) {
      callback();
    }
  };
  React.useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};
